import type { AnyAction } from "redux";
import type { ThunkAction } from "redux-thunk";
import type { GlobalState } from "../GlobalState";
import getAllSavedSearches from "../GrailedAPI/v1/SavedSearches/getAllSavedSearches";
import renameSavedSearch from "../GrailedAPI/v1/SavedSearches/rename";
import unsubscribeSavedSearch from "../GrailedAPI/v1/SavedSearches/unsubscribe";
import {
  CLOSE_MANAGE_SAVED_FILTERS_MODAL,
  OPEN_MANAGE_SAVED_FILTERS_MODAL,
  RENAME_SAVED_FILTER,
  UPDATE_APPLIED_SEARCH_ID,
  UPDATE_FILTER_NAMES,
  UPDATE_SAVED_FILTERS,
} from "./constants";

/**
 * IMPORTANT
 * DEPRECATED
 */
export function openManageSavedFiltersModal() {
  return {
    type: OPEN_MANAGE_SAVED_FILTERS_MODAL,
  };
}
export function closeManageSavedFiltersModal() {
  return {
    type: CLOSE_MANAGE_SAVED_FILTERS_MODAL,
  };
}
// Use the window path to set the app state's "appliedSearchId"
export function setCurrentAppliedSearchId(): ThunkAction<
  void,
  GlobalState,
  undefined,
  AnyAction
> {
  return (dispatch) => {
    const splitPaths = window.location.pathname.split("/");
    const path = splitPaths[1];
    let appliedSearchId;

    if (path === "designers" || path === "collaborations") {
      appliedSearchId = splitPaths[3];
    } else {
      appliedSearchId = splitPaths[2];
    }

    if (appliedSearchId) {
      dispatch({
        type: UPDATE_APPLIED_SEARCH_ID,
        payload: {
          appliedSearchId,
        },
      });
    }
  };
}
export function updateNotificationSettings(): ThunkAction<
  void,
  GlobalState,
  undefined,
  AnyAction
> {
  return (dispatch) => {
    getAllSavedSearches().then((savedSearches) => {
      dispatch({
        type: UPDATE_SAVED_FILTERS,
        payload: {
          savedSearches,
        },
      });
    });
  };
}

export function renameSavedFilter(
  uuid: string,
  name: string,
): ThunkAction<Promise<unknown>, GlobalState, undefined, AnyAction> {
  return (dispatch) =>
    renameSavedSearch(uuid, name)
      .then(() =>
        dispatch({
          type: RENAME_SAVED_FILTER,
        }),
      )
      .then(getAllSavedSearches)
      .then((savedSearches) =>
        dispatch({
          type: UPDATE_FILTER_NAMES,
          payload: {
            savedSearches,
          },
        }),
      );
}
export function deleteSavedFilter(
  uuid: string,
): ThunkAction<void, GlobalState, undefined, AnyAction> {
  return (dispatch) => {
    unsubscribeSavedSearch(uuid)
      .then(getAllSavedSearches)
      .then((savedSearches) =>
        dispatch({
          type: UPDATE_SAVED_FILTERS,
          payload: {
            savedSearches,
          },
        }),
      );
  };
}
